import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateItemTypeMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  update: Types.UpdateItemType;
}>;


export type UpdateItemTypeMutation = { __typename?: 'Mutation', updateItemType: { __typename?: 'ItemType', id: number } };


export const UpdateItemTypeDocument = gql`
    mutation UpdateItemType($id: Int!, $update: UpdateItemType!) {
  updateItemType(id: $id, update: $update) {
    id
  }
}
    `;
export type UpdateItemTypeMutationFn = Apollo.MutationFunction<UpdateItemTypeMutation, UpdateItemTypeMutationVariables>;

/**
 * __useUpdateItemTypeMutation__
 *
 * To run a mutation, you first call `useUpdateItemTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemTypeMutation, { data, loading, error }] = useUpdateItemTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateItemTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemTypeMutation, UpdateItemTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemTypeMutation, UpdateItemTypeMutationVariables>(UpdateItemTypeDocument, options);
      }
export type UpdateItemTypeMutationHookResult = ReturnType<typeof useUpdateItemTypeMutation>;
export type UpdateItemTypeMutationResult = Apollo.MutationResult<UpdateItemTypeMutation>;
export type UpdateItemTypeMutationOptions = Apollo.BaseMutationOptions<UpdateItemTypeMutation, UpdateItemTypeMutationVariables>;